/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import AccountAddressTile from './account-address-tile';
import AccountAddressTileView from './account-address-tile.view';

export * from './account-address-tile';
export * from './account-address-tile.data';
export { IAccountAddressTileConfig, IAccountAddressTileProps, IAccountAddressTileResources, ILinksData } from './account-address-tile.props.autogenerated';
export * from './account-address-tile.view';
export * from './components';

export {
    AccountAddressTile,
    AccountAddressTileView
};
